import colors from '../tokens/colors';

export const daDirektCodeDaDirekt = {
  color: colors.PROFESSIONAL_BLUE,
  typography: 'body',
  container: {
    backgroundColor: colors.WHITE,
    borderRadius: 8,
    padding: {
      mobile: '1rem',
    },
  },
  title: {
    backgroundColor: 'transparent',
    iconWidth: '1.5rem',
    padding: {
      mobile: 0,
    },
    typography: 'h3',
  },
  content: {
    padding: {
      mobile: 0,
      desktop: 0,
    },
  },
  success: {
    headline: {
      color: colors.DA_DIREKT_GRAY_3,
      fontWeight: 700,
    },
    subline: {
      color: colors.DA_DIREKT_GRAY_3,
      fontWeight: 500,
    },
  },
  error: {},
  input: {
    valid: {
      checkIconHeight: '1.5rem',
      deleteIconHeight: '1.25rem',
      iconSpacing: '0.75rem',
    },
  },
  button: {
    width: '10.25rem',
    states: {
      disabled: {
        color: colors.DA_DIREKT_BORDER_LINES,
        backgroundColor: 'transparent',
        border: '1px solid',
        borderColor: colors.DA_DIREKT_BORDER_LINES,
        opacity: 1,
      },
    },
  },
  modalTrigger: {
    color: colors.PROFESSIONAL_LIGHT_BLUE,
    fontWeight: 600,
  },
};

export const daDirektCodeDaKaufland = {
  color: colors.DA_KAUFLAND_BLACK,
  typography: 'p4',
  container: {
    backgroundColor: colors.WHITE,
    borderRadius: 0,
    padding: {
      mobile: '0 0 1rem',
    },
  },
  title: {
    backgroundColor: colors.DA_KAUFLAND_LIGHT_GRAY_2,
    iconWidth: '1.25rem',
    padding: {
      mobile: '0.625rem 0.5rem',
    },
    typography: 'h4',
  },
  content: {
    padding: {
      mobile: 0,
      desktop: '0 0.625rem 0 2.75rem',
    },
  },
  success: {
    headline: {
      color: colors.DA_KAUFLAND_BLACK,
      fontWeight: 400,
    },
    subline: {
      color: colors.DA_KAUFLAND_BLACK,
      fontWeight: 600,
    },
  },
  error: {},
  input: {
    valid: {
      checkIconHeight: '2.5rem',
      deleteIconHeight: '2.5rem',
      iconSpacing: '0.625rem',
    },
  },
  button: {
    width: '5rem',
    states: {
      disabled: {
        color: colors.WHITE,
        backgroundColor: colors.DA_KAUFLAND_BLACK,
        borderColor: 'transparent',
      },
    },
  },
  modalTrigger: {
    color: colors.DA_KAUFLAND_BLACK,
    fontWeight: 400,
  },
};
